import { useState } from "react";
import { OnlineFormRequestEditItemWidgetStyled } from "./styled";
import { userService } from "apiServices";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import momentTZ from "moment-timezone";
import { Buttons, Displays, Forms } from "components";

const OnlineFormRequestEditItemWidget = ({
  activity_form_history_id,
  answer,
  answer_list,
  _id,
  new_answer,
  page,
  question,
  pdpa_details,
  reject,
  type,
  is_request_edit,
  onRequestSuccess,
}) => {
  const { t, i18n } = useTranslation(["common", "form"]);

  const [_isBgLoading, _isSetBgLoading] = useState();
  const [_isEdit, _setIsEdit] = useState();

  const _handleEdit = () => {
    _setIsEdit(true);
  };

  const _handleSubmit = async (values) => {
    _isSetBgLoading(true);
    let params = {
      activity_form_history_id,
      page,
      question_id: _id,
      ...values,
    };
    let res = await userService.POST_ACTIVITY_FORM_HISTORY_REQUEST_EDIT(params);
    if (res && res.status === 200) {
      _isSetBgLoading(false);
      toast.success(t("Request success", { ns: "common" }));
      onRequestSuccess && onRequestSuccess();
    } else {
      _isSetBgLoading(false);
      toast.error(t("Request failed", { ns: "common" }));
    }
  };
  return (
    <OnlineFormRequestEditItemWidgetStyled>
      <Displays.BGLoading visible={_isBgLoading} />
      <div
        dangerouslySetInnerHTML={{
          __html: question,
        }}
      />
      {type === "4" && (
        <>
          <div className="pdpa_title">
            {i18n.language === "en"
              ? pdpa_details?.privacy_title_en
              : pdpa_details?.privacy_title_th}
          </div>
          <div
            className="pdpa_sub_title"
            dangerouslySetInnerHTML={{
              __html:
                i18n.language === "en"
                  ? pdpa_details?.privacy_body_en
                  : pdpa_details?.privacy_body_th,
            }}
          ></div>
        </>
      )}
      <div className="question_value">
        {t("Answer", { ns: "form" })}{" "}
        <span>
          {!answer
            ? "-"
            : type === "5"
            ? momentTZ(answer).tz("Asia/Bangkok").format("DD/MM/YYYY")
            : type === "4"
            ? i18n.language === "en"
              ? pdpa_details?.privacy_accept_label_en || "ยินยอม"
              : pdpa_details?.privacy_accept_label_th || "ยินยอม"
            : answer || "ไม่ได้ระบุ"}
        </span>
      </div>
      {new_answer && (
        <div className="question_value">
          {t("Answer Revision Requested", { ns: "form" })}{" "}
          <span>{new_answer}</span>
        </div>
      )}
      {reject && (
        <div className="reject_label">
          {t("Reason for Cancellation", { ns: "form" })} {reject}
        </div>
      )}
      {is_request_edit && (
        <div className="online_form_action_block">
          {!_isEdit ? (
            <div className="btn_req_edit_wrap">
              <Buttons.BgStandard
                label={t("Request to edit information", { ns: "form" })}
                onClick={_handleEdit}
              />
            </div>
          ) : (
            <div className="form_wrap">
              <Forms.OnlineFormRequestEditForm
                answer_list={answer_list}
                type={type}
                onSubmit={_handleSubmit}
              />
            </div>
          )}
        </div>
      )}
    </OnlineFormRequestEditItemWidgetStyled>
  );
};

export default OnlineFormRequestEditItemWidget;
